/**
 * Point d'entrée de l'application React : met en place l'élément racine et
 * rend le composant App dans le DOM.
 *
 * Inclus depuis `src/index.html`.
 */

import { ConvexProvider, ConvexReactClient } from "convex/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initPostHog } from "@repo/utils";
import { App } from "./app";

initPostHog("form");

const convexUrl = process.env.BUN_PUBLIC_CONVEX_URL;

if (!convexUrl) {
  throw new Error("La variable d'environnement CONVEX_URL est manquante !");
}

const convex = new ConvexReactClient(convexUrl);

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <ConvexProvider client={convex}>
      <App />
    </ConvexProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // Avec le rechargement à chaud des modules, `import.meta.hot.data` persiste.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // L'API de rechargement à chaud n'est pas disponible en production.
  createRoot(elem).render(app);
}
